export default "__VITE_ASSET__BEc6PtOQ__"